import { useRuntimeVariables } from 'app-kit'
import { useGeckoAuth } from 'features/auth'
import type { DocumentPageMetadataUserEditEntry } from 'features/knowledgeDocumentViewer/types/documentMetadataUserEditSchemas'
import { documentPageMetadataUserEditsBySite } from 'features/knowledgeDocumentViewer/utils/documentEntryLookups'
import { loadPageRevisionFamilyEdits } from 'features/knowledgeDocumentViewer/utils/loadPageRevisionFamilyEntries'
import { useMemo } from 'react'
import useSWR from 'swr'

export function usePageRevisionFamilyEdits(siteId: string, enabled: boolean) {
  const { authorizedAxios, isAuthenticated } = useGeckoAuth()
  const { ROLODEX_URL } = useRuntimeVariables()
  const options = useMemo(
    () =>
      documentPageMetadataUserEditsBySite({ site: siteId }, { limit: 1000 }),
    [siteId]
  )
  return useSWR<DocumentPageMetadataUserEditEntry[], Error>(
    enabled && siteId && isAuthenticated
      ? [
          `${ROLODEX_URL}/api/v2/entries/load`,
          JSON.stringify(options),
          'all-page-edit-events',
        ]
      : null,
    () =>
      loadPageRevisionFamilyEdits({
        axios: authorizedAxios,
        rolodexUrl: ROLODEX_URL,
        loadOptions: options,
      }),
    { keepPreviousData: false }
  )
}
